<template>

	<TopMenu :breadcrumbs="breadcrumbs"/>
	<Navigator />

	
	<div class="load-container load" v-if="isLoad"></div>

	<template v-if="!isLoad">

		<!-- {{ modules }} -->

	  <CollapseContainer 
	  	v-for="(item, index) in modules" 
	  	:key="index" 
	  	class="collapse--noborder"
	  	ref="module">

	    <template v-slot:header>
	    	<div class="c-ico" :style="{background: iconColor(item.moduleDonePercent).bg}">
					<component :is="item.moduleNum" :color="iconColor(item.moduleDonePercent).color"></component>
				</div>
				{{ item.moduleName }} &nbsp; <span :style="{'color': iconColor(item.moduleDonePercent).color}"> {{ item.moduleDonePercent + '%' }} </span>
	    </template>
	    <template v-slot:body>

	    	<table class="table-custom">
	    		<thead>
	    			<tr>
	    				<th width="50%"> Наименование </th>
	    				<th width="50%"> 
	    					Выполнение
	    				</th>

	    				<!-- <th width="50%" style="text-align: center;"> 
	    					<div class="c-badge">
	    						<span :style="{'background-color': 'var(--cozh-blue)'}"></span>
	    						Весенний сезон
	    					</div> 
	    				</th>
	    				<th width="25%" style="text-align: center;"> 
	    					<div class="c-badge">
	    						<span :style="{'background-color': 'var(--cozh-green)'}"></span>
	    						Осенний сезон 
	    					</div> 
	    				</th> -->
	    			</tr>
	    		</thead>
	    		<tbody>
	    			<tr v-for="(epic, idx) in item.epics" :key="idx">
	    				<td width="50%">
	    					<div class="epic__name">
	    						<span> {{ epic.epicNum }} </span> {{ epic.epicName }}
	    					</div>
	    				</td>
	    				<td width="50%" colspan="2">
    						
    						<!-- <DoubleProgressBarInflux 
    							:percent="epic.epicDonePercent" 
    							:count_left="epic.doneCount" 
    							:count_right="epic.planCount" 
    							color_left="var(--cozh-blue)"
    							color_right="var(--cozh-green)"
    						/> -->

    						<DoubleProgressBar 
    							:percent="epic.epicDonePercent" 
    							:count_left="epic.doneCount" 
    							:count_right="epic.planCount" 
    							color_left="var(--cozh-blue)"
    							color_right="var(--cozh-light-grey)"
    						/>


	    				</td>
	    			</tr>
	    		</tbody>
	    	</table>

	    </template>
	  </CollapseContainer>

	</template>

</template>

<script setup>

	import TopMenu from '@/components/TopMenu.vue';
	import Navigator from '@/components/reports/Navigator.vue';
  import CollapseContainer from '@/components/ux/CollapseContainer.vue'
	// import ProgressBar from '@/components/ux/ProgressBar.vue';
	import DoubleProgressBar from '@/components/ux/DoubleProgressBar.vue';
	// import DoubleProgressBarInflux from '@/components/ux/DoubleProgressBarInflux.vue';

	

  import A from '@/components/icons/modules/A.vue';
  import B from '@/components/icons/modules/B.vue';
  import C from '@/components/icons/modules/C.vue';
  import D from '@/components/icons/modules/D.vue';
  import E from '@/components/icons/modules/E.vue';
  import F from '@/components/icons/modules/F.vue';
  import G from '@/components/icons/modules/G.vue';
  import H from '@/components/icons/modules/H.vue';
  import I from '@/components/icons/modules/I.vue';
  import J from '@/components/icons/modules/J.vue';
  import K from '@/components/icons/modules/K.vue';
  import L from '@/components/icons/modules/L.vue';

</script>

<script>

  export default {
    name: 'PageReportsReadiness',
    components: { A, B, C, D, E, F, G, H, I, J, K, L },
    data: () => ({
      	isLoad: false,
      	breadcrumbs: [],
      	house: null,
      	modules: [],
      	state: {
      		A: { action: 'review' },
      		B: { action: 'review' },
      		C: { action: 'review' },
      		D: { action: 'review' },
      		E: { action: 'review' },
      		F: { action: 'review' },
      		G: { action: 'review' },
      		H: { action: 'review' },
      		I: { action: 'review' },
      	},
 
    }),

    computed: {
    	house_id () {
    		return this.$route.params.house_id;
    	},
    	iconColor () {
    		return (percent) => {
    			percent;
    			return {color: 'rgba(var(--cozh-blue-code), 1)', bg: 'rgba(var(--cozh-blue-code), .08)'};
    		}
    		// return (percent) => {
    		// 	if(percent >= 90) {
    		// 		return {color: 'rgba(var(--cozh-green-code), 1)', bg: 'rgba(var(--cozh-green-code), .08)'};
    		// 	}
				// 	if(percent < 90 && percent > 70) {
    		// 		return {color: 'rgba(var(--cozh-orange-code), 1)', bg: 'rgba(var(--cozh-orange-code), .08)'};
				// 	}
				// 	if(percent <= 70) {
    		// 		return {color: 'rgba(var(--cozh-red-code), 1)', bg: 'rgba(var(--cozh-red-code), .08)'};
				// 	}
    		// }
    	},
    },
    created () {
			this.loadData();
    	Promise.all([this.loadHouse()])
		    .then(() => {
		      this.beforeRender();
		    })
		    .catch(()=> {})
    },
    methods: {
    	beforeRender () {
    		this.breadcrumbs = [
	        	{name: this.$route.meta.name, link: this.$route.matched[0].path, ico: this.$route.meta.ico},
	        	{name: this.house.address, link: ''},
	        ];
    	},
    	async loadData () {
    		this.isLoad = true;
      	const {data} = await this.axios.get(this.$store.state.api_endpoint + '/dashboard/module/gop/' + this.house_id);
      	this.modules = data;
    		this.isLoad = false;
    	},

    	async loadHouse () {
      		this.house = await this.$store.dispatch('getHouse', {house_id: this.house_id});
    	},
    }
  }
</script>

<style scoped>

	.c-badge {
		display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    gap: 10px;
	}
	.c-badge span {
		display: block;
    height: 10px;
    width: 10px;
    border-radius: 2px;
    margin-top: 2px;
}

	.epic__name {
  	display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
	}
	.epic__name span {
		color: var(--cozh-grey);
    font-weight: 600;
	}


	.collapse:not(:last-child) {
		margin-bottom: 5px;
	}

	.collapse:deep(.collapse__header) {
		padding: 15px;
		font-weight: 500;
	}

	.collapse:deep(.collapse__body) {
		padding: 0px;
	}

	.c-ico {
		height: 50px;
    width: 50px;
    border-radius: 50%;
    background-color: #E9F1F4;
    margin-right: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
	}



	.component-filter {
		background-color: #fff;
		padding: 15px;
		border-radius: 8px;
		display: flex;
    	flex-direction: row;
    	align-items: center;
    	gap: 10px;
    	justify-content: space-between;
    	position: relative;
    	margin-bottom: 10px;
	}

	.component-filter__item {
		flex: 1 1 0;
  		width: 0;
	}
	.component-filter a {
		width: fit-content;
	}
	
</style>